// TODO: Stop video playing on popup close

// Capture and save scroll position and disable body scroll when modal active
let scrollPosition = 0;

function disableBodyScroll() {
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  document.body.classList.add('modal-open');
  document.body.style.top = `-${scrollPosition}px`;
}

function enableBodyScroll() {
  document.body.classList.remove('modal-open');
  document.body.style.top = '';
  window.scrollTo(0, scrollPosition);
}

function galleryVideoPlayer() {
  const videoThumbnail = document.querySelector('.js-video-thumbnail');
  let videoSelector = videoThumbnail.dataset.target;

  const popupWrapper = document.querySelector('.product-video-popup'),
        popupContainer = document.querySelector('.product-video-popup .popup-modal__content-info'),
        closeButton = document.querySelector('#ModalClose');
  
  videoThumbnail.addEventListener('click', (e) => {
    let mainVideoWrapper = document.querySelector(`.slider:not(.splide__list) [data-media-id='${videoSelector}']`);
    let videoContent = mainVideoWrapper.querySelector('template').content.firstElementChild.cloneNode(true);

    // Disable default video player
    mainVideoWrapper.querySelector('button.deferred-media__poster').disabled = true;
    mainVideoWrapper.querySelector('button.deferred-media__poster').style.pointerEvents = 'none';
    mainVideoWrapper.querySelector('.deferred-media__poster-button').style.display = 'none';
    
    popupContainer.innerHTML = '';
    popupContainer.appendChild(videoContent);

    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;    
        
    // Append popup to body
    popupWrapper.setAttribute('aria-hidden', false);
    popupWrapper.setAttribute('open', '');

    disableBodyScroll();
  });

  // Close popup when the close button is clicked
  closeButton.addEventListener('click', () => {
    popupWrapper.setAttribute('aria-hidden', true);
    popupWrapper.removeAttribute('open');
    popupWrapper.querySelector('video').pause();
    enableBodyScroll();
  });

  // Close popup when clicking outside the modal
  window.addEventListener('click', (e) => {
    if (e.target === popupWrapper) {
      popupWrapper.setAttribute('aria-hidden', true);
      popupWrapper.removeAttribute('open');
      popupWrapper.querySelector('video').pause();
      enableBodyScroll();
    }
  });
}

galleryVideoPlayer();

